import { render, staticRenderFns } from "./DashView.vue?vue&type=template&id=448c1d1d&"
import script from "./DashView.vue?vue&type=script&lang=js&"
export * from "./DashView.vue?vue&type=script&lang=js&"
import style0 from "./DashView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports